"use client";

import { AppButton } from "@/components/ui/Button";
import MaxWidth from "@/app/(main_app)/_components/MaxWidth";

// Shared CTA banner nudging the user toward a matched professional. What it
// shows depends on the caller's survey state — e.g. "browse professionals"
// once a city is picked, or "take the survey" when a match hasn't been requested
// yet — so content and the button's action are passed in rather than fixed here.
export default function ProfessionalMatchBanner({
  icon,
  title,
  description,
  buttonLabel,
  buttonIcon,
  onButtonClick,
  className,
  buttonClassName = "self-end",
  titleTypography = "m3-title-large text-[--textPrimaryPrimary]",
  descriptionTypography = "m3-body-medium text-[--textPrimaryPrimary]",
}) {
  return (
    <section className={`w-full bg-[--colorWarningWarning] ${className}`}>
      <MaxWidth padding="p-0">
        <div className="flex flex-col justify-between gap-5 px-4 py-6 md:flex-row">
          <div className="flex items-start gap-4">
            {icon}

            <div className="flex flex-col gap-1">
              <h2 className={titleTypography}>{title}</h2>
              <p className={descriptionTypography}>{description}</p>
            </div>
          </div>

          <AppButton
            label={buttonLabel}
            variant="contained"
            startIcon={buttonIcon}
            className={`whitespace-nowrap ${buttonClassName}`}
            typographyClass="m3-label-large font-manrope"
            onClick={onButtonClick}
            sx={{
              backgroundColor: "var(--colorSurfaceSurface)",
              color: "var(--colorPrimaryPrimary)",
              borderRadius: "var(--radius100)",
              fontWeight: 600,
              paddingX: "24px",
              paddingY: "12px",
              "&:hover": {
                backgroundColor: "var(--colorSurfaceSurface)",
                opacity: 0.9,
              },
            }}
          />
        </div>
      </MaxWidth>
    </section>
  );
}
